import * as Sentry from "@sentry/react";
import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'

import App from './App.tsx'
import './styles/global.css'

Sentry.init({
    dsn: "https://9d539313828c514efcdd635e65622411@o4509827581935617.ingest.us.sentry.io/4509827596943360",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration()
    ],
    // Tracing
    tracesSampleRate: parseInt(import.meta.env.VITE_PECUNIO_TRACE_SAMPLE), //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/pecunio\.ai/],
    environment: import.meta.env.NODE_ENV || "development",
});

const container = document.getElementById("root");
// @ts-expect-error DOM element could be null but createRoot handles it
const root = createRoot(container);

root.render(
    <StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </StrictMode>,
)